// extracted by mini-css-extract-plugin
module.exports = {"error":"NotFound_error__13VsV","wrapper":"NotFound_wrapper__1nhFz","page":"NotFound_page__Pdc-J","back":"NotFound_back__3NRFY"};